import { formulaNew } from "../../formula/formulaNew";
import type { DocMigration } from "../docMigration";

const DEFAULT_EAVE_OVERHANG = 12;
const DEFAULT_EAVE_RETURN_DISTANCE = 6;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_157: DocMigration = {
  maxSchemaVersion: "0.0.157",
  description: "Roof eave extension settings",
  apply(json: any) {
    const { settings: allSettings, roofs } = json;

    const getFormula = (settings: any, param: string, defaultValue: number = 0): string => {
      const val = settings[param];
      if (val !== undefined) {
        return val.type === "FORMULA" ? val.formula : val.toString();
      } else {
        return defaultValue.toString();
      }
    };

    // roof settings
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.eaveReturnDistance !== undefined) {
        const eaveOverhang = getFormula(settings, "eaveOverhang", DEFAULT_EAVE_OVERHANG);
        const eaveReturnDistance = getFormula(settings, "eaveReturnDistance");

        settings.eaveExtensionAtCoplanarRake = formulaNew(`${eaveReturnDistance} + ${eaveOverhang}`);
      }
    }

    // roof instances
    for (const roofId in roofs) {
      const { roofSettings = {} } = roofs[roofId];

      if (roofSettings.eaveReturnDistance !== undefined) {
        const eaveOverhang = getFormula(roofSettings, "eaveOverhang", DEFAULT_EAVE_OVERHANG);
        const eaveReturnDistance = getFormula(roofSettings, "eaveReturnDistance", DEFAULT_EAVE_RETURN_DISTANCE);

        roofSettings.eaveExtensionAtCoplanarRake = formulaNew(`${eaveReturnDistance} + ${eaveOverhang}`);
      }
    }

    return json;
  },
};

export default migration_0_0_157;
